import React, { useState } from 'react'
import Image from 'next/image'

import { GroupOptions } from './sub-menu'
import { addParagraphs } from '../src/formatter'
import ContentExpander from './content-expander'

const Component = ({ user, group, page }) => {
  if (group.theme === 'worldstroke') {
    return <div className='mb-8'>
      <div className='relative w-full mb-4 md:mb-8'>
        <a href='http://www.worldstrokecampaign.org/'>
          <Image 
            priority
            width={200} height={0}
            alt={group.name}
            sizes="(min-width: 768px) 900px, 400px"
            className='object-contain w-full block md:hidden'
            src='/wso-banner-mobile.png'
          />
          <Image 
            priority
            width={200} height={0}
            alt={group.name}
            sizes="(min-width: 768px) 900px, 400px"
            className='object-contain w-full hidden md:block h-auto'
            src='/wso-banner-web.png'
          />
        </a>
      </div>
      <div className='mb-8'>
        <GroupOptions user={user} page={page} group={group} />
      </div>
      <div className='text-gray-500 text-lg'>{addParagraphs(group.description)}</div>
    </div>
  }

  const GroupImage = ({ g }) => {
    const [error, setError] = useState(false)
    if (!g.logo) return <></>
    if (error) return <></>
    return <div className={`hidden md:block relative min-w-[250px] max-w-[250px]`}>
      <Image 
        width={0} height={0}
        alt={g.name}
        sizes="(min-width: 768px) 300px, 300px"
        className='object-contain rounded-md w-auto max-h-[250px] min-h-[200px] md:min-h-0 mx-auto'
        src={`${process.env.CDN}/${g.logo}`} 
        onError={() => setError(true)}
        />
    </div>
  }

  const GroupMenuDesc = () => {
    return <>
      <div className='text-3xl mb-2 mt-4 font-retro text-primary'>{group.name}</div>
      {(group && group.id && page === 'challenges' && group.description) && <div className='block md:hidden pb-10'>
        <ContentExpander content={addParagraphs(group.description)} />
      </div>}
      <div className='mb-12 md:mb-4'>
        <GroupOptions user={user} page={page} group={group} />
      </div>
      {(group && group.id && page === 'challenges' && group.description) && <div className='hidden md:block'>
        <ContentExpander content={addParagraphs(group.description)} />
      </div>}
    </>
  }

  return <div className='md:mb-20'>
    <div className='md:flex justify-center items-center mb-12 gap-4'>
      <GroupImage g={group} />
      {group.logo && <div className='md:hidden mb-4 w-full max-h-[250px] md:max-h-[300px]'>
        <GroupImage g={group} />
      </div>}
      <div className='grow'><GroupMenuDesc /></div>
    </div>
  </div>

}

export default Component
